
import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { MediaMatcher } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
;
import { AngularFirestore } from 'angularfire2/firestore';
import { ScrollService } from '../_services/scroll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { PARAMETERS } from '@angular/core/src/util/decorators';


@Component({
  selector: 'trend-topics',
  templateUrl: './trend-topics.component.html',
  styleUrls: ['./trend-topics.component.css']
})
export class TrendTopicsComponent implements OnInit, OnDestroy {
  hashtags: any;
  items: Observable<any[]>;
  brandItems: Observable<any[]>;
  brandHidden: Observable<any[]>;
  visible: any;
  isMobile = false;
  loadButton = false;
  isButton = false;
  isBrandButton = false;
  userId: any;
  hashList: Observable<any[]>;
  @Input() whichPage;
  private subscription = new Subscription();
  private subs = new Subscription();
  private subCat = new Subscription();
  constructor(private afs: AngularFirestore,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private media: MediaMatcher, private scrollService: ScrollService) {
    this.userId = localStorage.getItem('currentUserId');

    this.subCat.add(this.route.params.subscribe(params => {

      if (params.category && !this.userId) {
        this.isButton = true;

        this.afs.collection('categories').ref.where('uniqueName', '==', params.category).get()
          .then(data => {
            data.docs.map(brands => {
              this.brandItems = this.afs.collection('brands', ref => ref.where('category', '==', brands.data().name)
                .orderBy('myPosts', 'desc').limit(15)).valueChanges();
              this.brandHidden = this.afs.collection('brands', ref => ref.where('category', '==', brands.data().name)
                .orderBy('myPosts', 'desc')).valueChanges();

            })
          });
        setTimeout(() => {
          this.loadButton = true;

        }, 2500);



      }
      else if (params.category && this.userId) {
        this.subscription = this.scrollService.isScroll.subscribe(a => {
          if (document.querySelector(".perfect-scrollbar").scrollTop > 150) {
            this.visible = true;
          }
          else {
            this.visible = false;
          }
        })
        this.isButton = false;

        this.hashList = this.afs.collection('weeklyPosts', ref => ref.orderBy('order', 'asc')).snapshotChanges().pipe(map(actions => {
          return actions.map(a => {
            return {
              id: a.payload.doc.id,
              hashtagList: _.orderBy(Object.values(a.payload.doc.data()['hashtags']), 'total', 'desc').slice(0, 4),
              ...a.payload.doc.data()
            }
          });
        }));

      }
      else if (!params.category) {
        this.subscription = this.scrollService.isScroll.subscribe(a => {
          if (document.querySelector(".perfect-scrollbar").scrollTop > 150) {
            this.visible = true;
          }
          else {
            this.visible = false;
          }
        })
        this.isButton = false;
        this.isBrandButton = false;

        this.hashList = this.afs.collection('weeklyPosts', ref => ref.orderBy('order', 'asc')).snapshotChanges().pipe(map(actions => {
          return actions.map(a => {
            return {
              id: a.payload.doc.id,
              hashtagList: _.orderBy(Object.values(a.payload.doc.data()['hashtags']), 'total', 'desc').slice(0, 4),
              ...a.payload.doc.data()
            }
          });
        }));
      }
    }));
    this.isMobile = this.media.matchMedia('(max-width:1024px)').matches;





  }
  loadBrand() {
    const url = this.router.url;
    this.loadButton = false;
    console.log(url)
    if (this.whichPage === 'brand') {

      this.afs.collection('brands').ref.where('uniqueName', '==', url.split('/')[1]).get()
        .then(data => {
          data.docs.map(brands => {
            this.brandItems = this.afs.collection('brands', ref => ref.where('category', '==', brands.data().category)
              .orderBy('myPosts', 'desc')).snapshotChanges().pipe(map(action => {
                return action.filter(data1 => data1.payload.doc.data().uniqueName !== this.router.url.split('/')[1])
                  .map(c => c.payload.doc.data());
              }));
          })
        });
      setTimeout(() => {
        this.loadButton = true;

      }, 2500);
    }
    else {
      this.afs.collection('categories').ref.where('uniqueName', '==', url.split('/')[2]).get()
        .then(data => {
          data.docs.map(brands => {
            this.brandItems = this.afs.collection('brands', ref => ref.where('category', '==', brands.data().name)
              .orderBy('myPosts', 'desc')).valueChanges();

          })
        });
    }
    this.cd.markForCheck();


  }

  ngOnInit() {
    if (this.whichPage === 'brand' && !this.userId) {

      this.subs.add(this.route.params.subscribe(param => {
        this.isBrandButton = true;
        this.loadButton = true;
        this.subs.add(this.afs.collection('brands', ref => ref.where('uniqueName', '==', param.uniqueName.split('#')[0])).valueChanges().subscribe(data => {
          this.brandItems = this.afs.collection('brands', ref => ref.where('category', '==', data[0]['category'])
            .orderBy('myPosts', 'desc').limit(16)).snapshotChanges().pipe(map(action => {
              return action.filter(data => data.payload.doc.data().uniqueName !== param.uniqueName.split('#')[0])
                .map(c => c.payload.doc.data());
            }));
          this.brandHidden = this.afs.collection('brands', ref => ref.where('category', '==', data[0]['category'])
            .orderBy('myPosts', 'desc')).valueChanges();

          this.cd.markForCheck();
        }));

      }));
    }







  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.subs) {
      this.subs.unsubscribe();
    }
    if (this.subCat) {
      this.subCat.unsubscribe();
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/trend-topics/trend-topics.component.ts